import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=d1463a12&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1463a12')) {
      api.createRecord('d1463a12', component.options)
    } else {
      api.reload('d1463a12', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=d1463a12&", function () {
      api.rerender('d1463a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4C2EbMGq4iy33/JS/videoIframe.vue"
export default component.exports